import '@voice/ui-tokens/colors.css';
import '@voice/ui-tokens/motion.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './app/App';
import { Providers } from './app/providers';
import { initTelegram } from './app/telegram';

// Telegram SDK birinchi — viewport balandligi CSS o'zgaruvchisiga yozilishi
// kerak, aks holda birinchi render noto'g'ri balandlik bilan chiqadi.
initTelegram();

const root = document.getElementById('root');
if (!root) throw new Error('#root topilmadi');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </StrictMode>,
);
